import type { FertilityIntent } from "@src/packages/patients/patients.types";

type PlannedModality = NonNullable<
  FertilityIntent["plannedModalities"]
>[number];

/**
 * Resolve a single treatment choice from the multi-select builder field.
 *
 * A multi-select is a list of options the patient is considering, not an
 * accepted treatment path. Multiple choices, "not-sure", and an empty list
 * stay unresolved so downstream surfaces cannot silently turn uncertainty
 * into IVF.
 */
export function resolvePlannedModality(
  plannedModalities: readonly PlannedModality[] | null | undefined,
): Extract<PlannedModality, "ivf" | "iui"> | null {
  const selected = new Set(
    (plannedModalities ?? []).filter(
      (modality): modality is Extract<PlannedModality, "ivf" | "iui"> =>
        modality === "ivf" || modality === "iui",
    ),
  );

  if (selected.size !== 1) return null;
  return selected.values().next().value ?? null;
}
